export default () => {
    const password = document.getElementById('password-checker');
    if (!password)
        return;
    import(/* webpackChunkName: "password checker" */ "./../classes/passwordCheckerClass")
        .then(({ default: PasswordChecker }) => {
        new PasswordChecker();
    })
        .catch(() => "An error with password checker occurred");
};
